export const Tabs = ({ children }) => <div>{children}</div>;
export const TabsContent = ({ value, children }) => <div>{children}</div>;
export const TabsList = ({ children }) => <div>{children}</div>;
export const TabsTrigger = ({ value, children }) => <button>{children}</button>; 